export default __webpack_public_path__ + "static/paintingEmpress-cb4bfeaa088d63402478c95b2a175a1c.svg";